import React from "react";
import { NavLink } from "react-router-dom";
import { LayoutDashboard, KanbanSquare, Database, Sparkles, Target, Compass, LogOut, Settings } from "lucide-react";
import { useAuth } from "../context/AuthContext";

const items = [
  { to: "/", label: "Dashboard", icon: LayoutDashboard, testid: "nav-dashboard" },
  { to: "/pipeline", label: "Pipeline", icon: KanbanSquare, testid: "nav-pipeline" },
  { to: "/database", label: "Database", icon: Database, testid: "nav-database" },
  { to: "/discover", label: "Scopri AI", icon: Compass, testid: "nav-discover" },
  { to: "/kpi", label: "KPI Settimanali", icon: Target, testid: "nav-kpi" },
  { to: "/settings", label: "Impostazioni", icon: Settings, testid: "nav-settings" },
];

export default function Sidebar() {
  const { user, logout, authRequired } = useAuth();
  return (
    <aside
      className="fixed left-0 top-0 z-30 flex h-screen w-60 flex-col border-r border-border bg-[#080B12]"
      data-testid="sidebar"
    >
      <div className="flex items-center gap-2.5 px-6 py-6">
        <div className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary/15 ring-1 ring-primary/30">
          <span className="font-heading text-sm font-bold text-primary">20</span>
        </div>
        <div className="leading-tight">
          <div className="font-heading text-base font-bold tracking-tight">20/80LAB</div>
          <div className="text-[0.65rem] uppercase tracking-[0.15em] text-muted-foreground">
            Acquisition
          </div>
        </div>
      </div>

      <nav className="flex-1 space-y-1 px-3 py-2">
        {items.map((it) => (
          <NavLink
            key={it.to}
            to={it.to}
            end={it.to === "/"}
            data-testid={it.testid}
            className={({ isActive }) =>
              `group flex items-center gap-3 rounded-lg px-3 py-2.5 text-sm font-medium transition-colors duration-200 ${
                isActive
                  ? "bg-primary/12 text-primary"
                  : "text-muted-foreground hover:bg-secondary hover:text-foreground"
              }`
            }
          >
            <it.icon className="h-[18px] w-[18px]" strokeWidth={1.75} />
            {it.label}
          </NavLink>
        ))}
      </nav>

      <div className="m-3 rounded-xl border border-border bg-card p-4">
        <div className="mb-1 flex items-center gap-2 text-sm font-semibold">
          <Sparkles className="h-4 w-4 text-primary" strokeWidth={1.75} />
          Client Acquisition
        </div>
        <p className="text-xs leading-relaxed text-muted-foreground">
          FIND → SCORE → AUDIT → MATCH → CONTACT → QUALIFY → CONVERT → FOLLOW-UP
        </p>
      </div>

      {user && (
        <div className="mx-3 mb-3 flex items-center gap-3 rounded-xl border border-border bg-card p-3" data-testid="user-card">
          {user.picture ? (
            <img src={user.picture} alt="" className="h-8 w-8 rounded-full object-cover" referrerPolicy="no-referrer" />
          ) : (
            <div className="flex h-8 w-8 items-center justify-center rounded-full bg-primary/15 text-xs font-semibold text-primary">
              {(user.name || user.email || "?").slice(0, 1).toUpperCase()}
            </div>
          )}
          <div className="min-w-0 flex-1">
            <div className="truncate text-sm font-medium">{user.name || "Utente"}</div>
            <div className="truncate text-xs text-muted-foreground">{authRequired ? user.email : "Accesso libero · nessun login"}</div>
          </div>
          {authRequired && (
            <button onClick={logout} data-testid="logout-btn" title="Esci"
              className="rounded-lg p-1.5 text-muted-foreground transition-colors hover:bg-secondary hover:text-foreground">
              <LogOut className="h-4 w-4" />
            </button>
          )}
        </div>
      )}
    </aside>
  );
}
